import $ from 'jquery';
import { $doc } from '../utils/globals';

$doc.on('click', '.js-win-reload', () => location.reload());
